import { View, Text, StyleSheet } from 'react-native'
import React from 'react'
import Svg, { Circle, Path } from 'react-native-svg'; 

const GiveawayIcon = ({color, width, height}) => {
    return (
        <View>
            <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
                <Circle cx="17" cy="8" r="4" stroke={color} />
                <Circle cx="12" cy="17" r="3" stroke={color} />
                <Circle cx="6.5" cy="9.5" r="2.5" stroke='#222222'  />
            </Svg>
        </View>
    )
}

const styles = StyleSheet.create({})

export default GiveawayIcon
